<template>
  <section>
    <v-img src="/images/banner1.jpg" class="banner" aspect-ratio="6.0">
      <div class="fill-height fundo"></div>
      <div class="stage">
        <div class="layer" v-for="n in 20" :key="n"></div>
      </div>
    </v-img>
  </section>
</template>

<script>
export default {
  data: () => ({}),
  props: ["title", "img", "effect"],
  components: {},
  computed: {
    classes: () => {
      return { "fill-height": true, effect1: true };
    }
  }
};
</script>

<style lang="scss" scoped>
// google font subsetting, see Heydon Pickering's: http://www.sitepoint.com/joy-of-subsets-web-fonts/
@import url("//fonts.googleapis.com/css?family=Pacifico");

/* Blue */
$corFundo: #42a4f5;
$corBorda: darken(#42a4f5, 10%);
$corLetra: darken(white, 0%);
$texto: "Equipe";
$tamanhoTexto: 90px;
$larguraTexto: 690px;
$alturaTexto: 300px;

/* Orange */
// $corFundo: #F38020;
// $corBorda: white;
// $corLetra: darken($corFundo, 10%);

.fundo {
  background-image: repeating-linear-gradient(
    -45deg,
    rgba(32, 150, 243, 0.8),
    rgba(32, 150, 243, 0.8) 5px,
    rgba(32, 150, 243, 1) 5px,
    rgba(32, 150, 243, 1) 10px
  );

  // background: radial-gradient(
  //   circle,
  //   darken($corFundo, 0),
  //   darken($corFundo, 0),
  //   darken($corFundo, 0),
  //   darken($corFundo, 0)
  // );
}

.stage {
  height: 300px;
  width: $larguraTexto;
  margin: auto;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  perspective: 9999px;
  transform-style: preserve-3d;
}

.layer {
  width: 100%;
  height: 100%;
  position: absolute;
  transform-style: preserve-3d;
  animation: ಠ_ಠ 5s infinite alternate ease-in-out -7.5s;
  animation-fill-mode: forwards;
  transform: rotateY(10deg) rotateX(15deg) translateZ(0);
}

.layer:after {
  font: $tamanhoTexto "Pacifico", Impact, sans-serif;
  content: $texto;
  white-space: pre;
  text-align: center;
  height: 100%;
  width: 100%;
  position: absolute;
  top: 70px;
  color: darken($corLetra, 4%);
  letter-spacing: -2px;
  text-shadow: 4px 0 10px hsla(0, 0%, 0%, 0.13);
}

$i: 1;
$NUM_LAYERS: 20;
@for $i from 1 through $NUM_LAYERS {
  .layer:nth-child(#{$i}):after {
    transform: translateZ(($i - 1) * -1.5px);
  }
}

.layer:nth-child(n + #{round($NUM_LAYERS/2)}):after {
  -webkit-text-stroke: 3px hsla(0, 0%, 0%, 0.25);
}

.layer:nth-child(n + #{round($NUM_LAYERS/2 + 1)}):after {
  -webkit-text-stroke: 15px $corBorda;
  text-shadow: 6px 0 6px darken($corBorda, 35%),
    5px 5px 5px darken($corBorda, 40%), 0 6px 6px darken($corBorda, 35%);
}

.layer:nth-child(n + #{round($NUM_LAYERS/2 + 2)}):after {
  -webkit-text-stroke: 15px darken($corBorda, 10%);
}

.layer:last-child:after {
  -webkit-text-stroke: 17px hsla(0, 0%, 0%, 0.1);
}

.layer:first-child:after {
  color: $corLetra;
  text-shadow: none;
}

@keyframes ಠ_ಠ {
  100% {
    transform: rotateY(-5deg) rotateX(-5deg);
  }
}

// XS
@media screen and (max-width: 600px) {
  .stage {
    width: $larguraTexto * 0.5;
    height: $alturaTexto * 0.78;
  }
  .layer:after {
    font-size: ($tamanhoTexto * 0.5);
  }
}

// SM
@media screen and (max-width: 960px) and (min-width: 601px) {
  .stage {
    width: $larguraTexto * 0.6;
    height: $alturaTexto * 0.78;
  }
  .layer:after {
    font-size: ($tamanhoTexto * 0.6);
  }
}

// MD
@media screen and (max-width: 1264px) and (min-width: 961px) {
  .stage {
    width: $larguraTexto * 1;
    height: $alturaTexto * 0.9;
  }
  .layer:after {
    font-size: ($tamanhoTexto * 0.8);
  }
}

// LG
@media screen and (max-width: 1904px) and (min-width: 1265px) {
  .text3d {
    font-size: 130px;
  }
}

// XL
@media screen and (min-width: 1905px) {
}
</style>

